module.exports = __webpack_public_path__ + "img/asae.f70ad15f.png";